/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contact_ObservationInputs */

const en_clients_field_contact_observation = /** @type {(inputs: Clients_Field_Contact_ObservationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observation`)
};

const pt_br2_clients_field_contact_observation = /** @type {(inputs: Clients_Field_Contact_ObservationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observação`)
};

/**
* | output |
* | --- |
* | "Observation" |
*
* @param {Clients_Field_Contact_ObservationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contact_observation = /** @type {((inputs?: Clients_Field_Contact_ObservationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contact_ObservationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contact_observation(inputs)
	return pt_br2_clients_field_contact_observation(inputs)
});